'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencySymbol = exports.getDepositAmountValidationI18nd = exports.sumValues = exports.digit = exports.onlyNumbers = exports.number = exports.isRequired = exports.onlyNumbersDecimals = undefined;

var _sprintfJs = require('sprintf-js');

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _currencySignFormatter = require('./currencySignFormatter');

/**
 * Validate a string containing only numbers and . decimal separator.
 * If it doesn't validate, previousValue is returned
 *
 * @param {string} value string to validate
 * @param {string} previousValue previous value
 * @returns {string} validated string
 */
var onlyNumbersDecimals = exports.onlyNumbersDecimals = function onlyNumbersDecimals(value, previousValue) {
  var VALUE_MAX_LENGTH = 15; //max number of accepted chars for the value string
  if (value.match(/^[0-9.]*$/) || value === '') {
    return value.length <= VALUE_MAX_LENGTH ? value : previousValue;
  }
  return previousValue;
};

/**
 * Validation helper. It returns undefined (no errors) if the value exists
 * Otherwise the message value is returned
 *
 * @param {string} message Error message
 * @returns {string|undefined} Error message or undefined if no validation error
 */
var isRequired = exports.isRequired = function isRequired(message) {
  return function (value) {
    return value ? undefined : message;
  };
};

/**
 * Validation helper. It returns undefined (no errors) if the value is a number
 * Otherwise the message value is returned
 *
 * @param {string} message Error message
 * @returns {string|undefined} Error message or undefined if no validation error
 */
var number = exports.number = function number(message) {
  return function (value) {
    return value && isNaN(Number(value)) ? message : undefined;
  };
};

/**
 * Normalization helper. Only allows numeric chars.
 *
 * @param {number} limit Max length
 * @returns {string} The normalised string
 */
var onlyNumbers = exports.onlyNumbers = function onlyNumbers(limit) {
  return function (value, previousValue) {
    return (value.match(/^\d+$/) || value === '') && value.length <= limit ? value : previousValue;
  };
};

/**
 * Validation helper. Allows only a specific length numberic string.
 *
 * @param {number} limit Max length
 * @param {string} message Error message
 * @returns {string|undefined} Error message or undefined in case validation passed
 */
var digit = exports.digit = function digit(limit, message) {
  return function (value) {
    return value && (isNaN(Number(value)) || value.length !== limit) ? message : undefined;
  };
};

/**
 * Given 2 string representing float numbers, this function adds them an then returns
 * the result as a string with 2 decimal values.
 *
 * @param {string} val1 Value 1
 * @param {string} val2 Value 2
 * @returns {string} the result of the sum in 'DDD.DD' format. If anything goes wrong '0.00' is returned
 */
var sumValues = exports.sumValues = function sumValues(val1, val2) {
  return !isNaN(val1) && !isNaN(val2) ? (0, _quickDepositLogic.formatNumber)((parseFloat(val1) + parseFloat(val2)).toString(), 2) : '0.00';
};

var getDepositAmountValidationI18nd = exports.getDepositAmountValidationI18nd = function getDepositAmountValidationI18nd(t, pApiValidator, currencyValue, currencyCode) {
  return function (amount, allValues) {
    var res = pApiValidator(amount, allValues);
    return res ? (0, _sprintfJs.vsprintf)(t(res.code), {
      currency: currencyValue,
      amount: res.payload[0],
      nextDepAmt: res.payload.pmtNextDepAmt,
      time: res.payload.nextDepHour,
      date: res.payload.nextDepDate,
      amountWithCurrency: (0, _currencySignFormatter.currencySignFormatter)('' + res.payload[0], currencyCode).join(''),
      nextDepAmtWithCurrency: (0, _currencySignFormatter.currencySignFormatter)('' + res.payload.pmtNextDepAmt, currencyCode).join('')
    }) : res;
  };
};

var currencySymbols = {
  USD: '$', // US Dollar
  EUR: '€', // Euro
  CRC: '₡', // Costa Rican Colón
  GBP: '£', // British Pound Sterling
  ILS: '₪', // Israeli New Sheqel
  INR: '₹', // Indian Rupee
  JPY: '¥', // Japanese Yen
  KRW: '₩', // South Korean Won
  NGN: '₦', // Nigerian Naira
  PHP: '₱', // Philippine Peso
  PLN: 'zł', // Polish Zloty
  PYG: '₲', // Paraguayan Guarani
  THB: '฿', // Thai Baht
  UAH: '₴', // Ukrainian Hryvnia
  VND: '₫' // Vietnamese Dong
};

/**
 * Returns currency symbol base onn ccy
 * @param {string} ccy ccy symbol
 * @return {string} currency symbol
 */
var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol(ccy) {
  return currencySymbols[ccy] || ccy;
};